<template>
    <Spinner v-if="isLoading" />
	<div class="grid nested-grid">

		<div class="col-12">								
			<div class="card fluid cardheader">
				<div class="col-12">
					<h5 class="stationsHeader">{{ translated('dashboardusace').toUpperCase() }}</h5> 
				</div>												
			</div>	
        </div>
<!-- 
        <div class="col-12">
            CompanyId: {{ getCompanyId }}
        </div> -->
		<div class="col-6">
			<!-- <div v-if="isMinisterstvo && getCompanyId!=undefined" class="card fluid cardheader">
				<div class="col-12">
                    <Button icon="pi pi-file-o" :label="translated('createdoc')" class="p-button-raised p-button p-button-sm btnCreateDoc" />
				</div>												
			</div>	 -->


			<div v-if="isMinisterstvo && getCompanyId==undefined" class="card fluid">
				<div class="col-12 cardKocke statProviders">
                    <div class="field grid">
                        <div class="col-6">
                            <div class="card fluid cardNewCompanies" @click="clickNew">
                                <h4>{{ translated('newregistereducase') }}</h4>
                                <span class="kockaStevilka">{{ Stats.NewCompanies }}</span>
                            </div>
                        </div>  
                        <div class="col-6">
                            <div class="card fluid cardWithoutCode" @click="clickWithoutCode">
                                <h4>{{ translated('companywithoutmspcodeucase') }}</h4>
                                <span class="kockaStevilka">{{ Stats.CompaniesWithoudCode }}</span>
                            </div>
                        </div>                                                                                               
                    </div>
				</div>	              											
			</div>	             
            <!-- <Company :companyid="getCompanyId" :key="paramCompanyId" /> -->
            <Company :companyid="getCompanyId" :key="getCompanyId" />
        </div>
       
		<div class="col-6">
			<div class="card fluid">                
				<div class="col-12 cardKocke cardStats">                    
                    <div class="field grid">
                        <div class="col-12 statPolnilnica">{{ translated('dbtitlepp') }}</div>
                        <div class="col-3">
                            <div class="card fluid cardAll">
                                <h4>{{ translated('allstationcount') }}</h4>
                                <span class="kockaStevilka">{{ Stats.AllLocations }}</span>
                            </div>
                        </div>  
                        <div class="col-3">
                            <div class="card fluid cardPublic">
                                <h4>{{ translated('publicstationscount') }}</h4>
                                <span class="kockaStevilka">{{ Stats.PublicLocations }}</span>
                            </div>
                        </div> 
                        <div class="col-3">
                            <div class="card fluid cardActive">
                                <h4>{{ translated('activestationcount') }}</h4>
                                <span class="kockaStevilka">{{ Stats.ActiveLocations }}</span>
                            </div>
                        </div> 
                        <div class="col-3">
                            <div class="card fluid cardInUse">
                                <h4>{{ translated('inusecount') }}</h4>
                                <span class="kockaStevilka">{{ Stats.InUseLocations }}</span>
                            </div>
                        </div>                                                                                               
                    </div>
				</div>	

				<div class="col-12 cardKocke cardStats">                    
                    <div class="field grid">
                        <div class="col-12 statPolnilnica">{{ translated('dbtitlepm') }} </div>
                        <div class="col-6">
                            <div class="card fluid cardAll">
                                <h4>{{ translated('allrefillpoints') }}</h4>
                                <span class="kockaStevilka">{{ Stats.AllRefillPoints }}</span>
                            </div>
                        </div>  
                        <div class="col-6">
                            <div class="card fluid cardPublic">
                                <h4>{{ translated('inuserefillpoint') }}</h4>
                                <span class="kockaStevilka">{{ Stats.InUseRefillPoints }}</span>
                            </div>
                        </div>                                                                                            
                    </div>
				</div>	     

				<div class="col-12 cardMapa">
                    <div id="rm2Map" style="height: 100%; width: 100%" :style-url="`${publicPath}vector.prometej.mb-style.json`"></div>                    
                    <!-- <div id="rm2Map" style="height: 100%; width: 100%" style-url="https://gis-dars.geoprostor.net/vt/styles/vector.prometej.mb-style.json"></div> -->
				</div>	                											
			</div>	            
        </div>
    </div>

</template>

<script>
import '@/assets/RM2MapControls.css';
import { computed } from "vue";
import Company from '@/components/Company.vue';
import createHttp from "@/services/http";
import store from "@/store";
import Spinner from "@/components/Spinner.vue"


export default {
    components: { Company, Spinner },    
    props: ['companyid'],
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isLoading: true,
            Stats: { },
            StNovihPodjetji: 0,
            StBrezKod: 0,
            paramCompanyId: '',
            translated: computed(() => store.getters.getTranslate),
            mc: {}
        }
    },    
    computed: {
        isMinisterstvo() {
            return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));
        },
        isReadOnly() {
            return this.$store.getters.isInRole("ReadOnly");
        },        
        getCompanyId() {
            return this.paramCompanyId;
        }
    },

    
    // mounted() {
    //     console.log('MOUNTED Dashboard CONTROL !!!!', this.companyid);
    // },    
    
    async created() {
        // console.log('KLIČEM CREATED MDashboard.vue CONTROL !!!!', this.$store.getters.getRole, this.companyid);
        //console.log(this.companyid);        
        this.paramCompanyId = this.companyid;        

        //console.log('Pred Load Data');
        await this.loadData();
        //console.log('Konec LOAD DATA');

        //console.log('Kreiram this.mc');
        this.mc = new rmap2.MapContainer("rm2Map");
        //console.log('KREIRANO this.mc');
        // debugger;
        // console.log(this.Stats.EnergySites);
        // Dodam pine
        this.mc.evt_mapLoad.subscribe(() => {

            var fcol = {
                type: 'FeatureCollection',
                features: []
            };

            this.Stats.EnergySites.forEach(element => {
            // console.log('logiram elemente ki jih risem');
            // console.log(element);
                if(!isNaN(element.Long) && !isNaN(element.Lat))
                {
                    //var geometry = {"type": "Point","coordinates": [ element.Long, element.Lat ]};                    
                    //console.log(geometry);   
                    /*                 
                    this.mc.drawMarker(
                        geometry, {
                            minResolution: 1,
                            projection: 'EPSG:4326',
                            pan: true,
                            animate: true,
                            size: 0.25,
                            icon: 'marker_red-128',
                            relCenterX: 0.5,
                            relCenterY: 0.5
                        }
                    );  
                    */
                    // console.log('Logiram element, ki a dodajam na mapo');
                    // console.log(element);
                    var pointElement = {
                        type: 'Feature',
                        properties: {
                            icon: 'marker_red-128',
                            size: 0.25,
                            id: element.Id,
                            businessname: element.BusinessName,
                            businessid: element.BusinessId
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: [ element.Long, element.Lat ]
                        },
                        includeInIdentify: false
                    }

                    fcol.features.push(pointElement);

                    //this.mc.addFeatures

                }
            });

            // console.log('dam notri FeatureCollection');
            // console.log(fcol);
            this.mc.addFeatures(fcol)
        });

        // Klik na en element na mapi, pa potem routanje na njegov edit
        this.mc.evt_mapClick.subscribe(e => {
            //console.log('Kliknil sem na en element');
            //console.log(e.features);
            if (e.features.length>0) {
                const ft = e.features[0];
                console.log('kliknil sem na element');
                console.log(ft);

                const myId = e.features[0].properties.id;
                const myCompanyname = e.features[0].properties.businessname
                const myCompanyId = e.features[0].properties.businessid;
                console.log('properties Name:' + myCompanyname);
                console.log('properties Id:' + myCompanyId);

                // Delam routing na Edit te lokacije
                this.$router.push({ name: 'EditEnergySite', params: { id: myId, viewedCompanName: myCompanyname, viewcompanyid: myCompanyId }});
            }
            //const ft = e.features.find(x => x.properties.id === 'nek ID');
        });


        //console.log('Zacnem marker');
        //debugger;
        /*
        this.mc.drawMarker(
            geometry,
            {
                minResolution: 1,
                projection: 'EPSG:4326',
                pan: true,
                animate: true,
                icon: 'marker_red-128',
                autoZoom: true,
                relCenterX: 0.5,
                relCenterY: 0.5
            });   
            */
            /*
        let lineObj = {
            "type": "LineString",
            "coordinates": [
                [ 14.483950323316735, 46.05451539613433 ],
                [ 14.48394754515896, 46.05452231179189 ],
                [ 14.483939951494342, 46.05453289474514 ],
                [ 14.483870248953221, 46.0545243920497 ],
                [ 14.483792161280625, 46.05450046541939 ],
                [ 14.48378673655723, 46.054500170982644 ],
                [ 14.483772954659911, 46.054523052773634 ],
                [ 14.483704089361152, 46.05461883672974 ],
                [ 14.483696951221087, 46.05462213361403 ],
                [ 14.483579730735662, 46.05481757310473 ],
                [ 14.483620963105371, 46.054830446155324 ],
                [ 14.4836288237645, 46.054832821071474 ]
            ]
        };

        this.mc.drawLine(
                lineObj,
                {
                    projection: 'EPSG:4326',
                    pan: true,
                    // animate: document.getElementById('animateLineHighlight').checked,
                    lineColor: '#639FFF',
                    lineOpacity: 0.5,
                    lineWidth: 7
                }
            );
*/
        //console.log('Končam marker');
        
    }, 
    methods: {
        clickNew() {
            this.$router.push({ name: 'Companies', params: { approved: 0 } });
        },
        clickWithoutCode() {
            this.$router.push({ name: 'Companies', params: { approved: 2 } })
        },
        async loadData() {
            let DashBoardUrl = process.env.VUE_APP_API_FOLDER + "/GetCompanyDashboardData";

            debugger;
            if(this.paramCompanyId) {
                if(this.paramCompanyId!='00000000-0000-0000-0000-000000000000') {
                    DashBoardUrl = DashBoardUrl + '?loadCompanyId=' + this.paramCompanyId
                }                  
            }

            //console.log(DashBoardUrl);
            
            // klicem server da mi vrne stat. podatke o lokacijah
            const http = createHttp(true);
            const resultGC = await http.get(DashBoardUrl);
            //console.log(resultGC);
            if (resultGC.status == 200) {
                this.Stats = resultGC.data;		
                

                console.log(this.Stats)
            }   
            this.isLoading = false;
            //console.log('konec metode loaddata');            
        }
    }      
}
</script>

<style scoped>

button.btnCreateDoc {
    width: auto;
}

.cardKocke span {
    font-size: 40px;
    font-weight: bold;
}

/* .col-12.cardKocke {
    height: 150px;
} */

.col-12.cardMapa {
    height: 487px;
}

.card.fluid.cardNewCompanies {
    background: #fdd78f;
    text-align: center;
    cursor: pointer;
}

.card.fluid.cardWithoutCode {
    background: #f88f17;
    text-align: center;
    cursor: pointer;
}

.card.fluid.cardAll {
    background: #ced4da;
    text-align: center;
}

.card.fluid.cardPublic {
    background: #c6deb1;
    text-align: center;
}

.card.fluid.cardActive {
    background: #a6d5fa;
    text-align: center;
}

.card.fluid.cardInUse {
    background: #ffdd87;
    text-align: center;
}

h4 {
    font-size: 1.4rem;
}

.cardStats .card.fluid {margin-bottom:0px;padding:5px !important;}
.cardStats .card.fluid h4{ font-size: 1.1rem;margin-bottom:0px}
.cardStats .card.fluid span {font-size:18px;}

.col-12.statPolnilnica {padding-top: 0px;padding-bottom: 5px !important;font-weight: bold;}
.col-12.cardKocke.cardStats {padding-bottom: 0px;padding-top: 0px;}

.col-12.cardKocke.statProviders .card.fluid { padding:23px;}


</style>